import { useEffect } from "react";
import { useLocation } from "react-router";

export const ScrollUtils = () => {
  const location = useLocation();
  const { hash } = location;

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [hash]);

  useEffect(() => {
    // if there is no hash, scroll to top when the pathname changes
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  return null;
};
